import sampleData from '~/modules/scans/data/sample-documents.json';
export const getScanDocuments = async () => {
    return sampleData;
};
